import { useMemo } from 'react'

import { Group } from '@mui/icons-material'
import { Avatar, Typography } from '@mui/material'
import { OrgTeam } from '@nativewaves/nw-cloud-sdk/org'
import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'domain'])

  return useMemo<ColumnDef<OrgTeam>[]>(
    () => [
      {
        id: '_image',
        header: () => null,
        meta: {
          sizing: {
            width: 64,
            px: 2,
          },
          align: 'center',
        },
        cell: () => (
          <Avatar sx={{ width: 32, height: 32, bgcolor: 'background.levels.900' }}>
            <Group fontSize="inherit" color="info" />
          </Avatar>
        ),
      },
      {
        accessorKey: 'name',
        header: t('name'),
        meta: {
          sizing: {
            minWidth: 300,
          },
        },
        cell: ({ getValue }) => (
          <Typography
            sx={{ color: (theme) => (!getValue() ? theme.palette.action.disabled : 'inherit') }}
            variant="inherit"
            noWrap
          >
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            width: 200,
            px: 2,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
    ],
    [t],
  )
}
